import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { currentRouteSet } from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import { pathSpliter, dateTimeFormat, currentDateTime, getDateTimeFromISODT, currentDateStartTime, currentDateEndTime } from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import { API_URL } from '../../config';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import _ from 'lodash';
import PrintIcon from '@material-ui/icons/Print';
import Select from 'react-select';
import { NetworkLoaderOverlay } from "../commons/NetworkLoader";


import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';
import InstitutionProfile from '../commons/institution_profile'
import ReactToPrint from "react-to-print";
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')

const createCalculatorState = (value = 0) => ({
  totalSales: String(value),
  totalPurchaseAmount: String(value),
  saleProfitLoss: String(value),
  cashTranProfit: String(value),
  serviceIncomeAmount: String(value),
  serviceExpenseAmount: String(value),
  salesDiscount: String(value),
  productDamageAmount: String(value),
  materialDamageAmount: String(value),
  cashTranLoss: String(value),
  employeeSalaryPay: String(value),
});

const toSafeNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const CustomerTransactionHistory = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const isCalculatorPage = location?.pathname?.includes('/reports/profit-calculator') || location?.search?.includes('calculator=1');
  const getYearRange = (year = moment().year()) => ({
    fromDate: moment().year(Number(year)).startOf('year').toDate(),
    toDate: moment().year(Number(year)).endOf('year').toDate(),
  });
  const classes = useStyles();
  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
  }, []);
  let [customers, customersSet] = useState([]);
  let [selectedCustomer, selectedCustomerSet] = useState(null);
  let [report, reportSet] = useState([]);
  let [othersReport, othersReportSet] = useState(null);
  let [print, printSet] = useState(false);
  let [reportLoading, reportLoadingSet] = useState(false);

  let [totalSoldAmount, totalSoldAmountSet] = useState(0);
  let [totalPurchaseAmount, totalPurchaseAmountSet] = useState(0);
  let [totalSaleProfitLoss, totalSaleProfitLossSet] = useState(0);
  let [totalSaleDiscount, totalSaleDiscountSet] = useState(0);

  let [products, productsSet] = useState([]);
  let [selectedProduct, selectedProductSet] = useState(null);
  let [productWiseProfit, productWiseProfitSet] = useState([]);
  let [productProfit, productProfitSet] = useState(0);
  let [calculatorLoading, calculatorLoadingSet] = useState(false);
  let [calculatorValues, calculatorValuesSet] = useState(createCalculatorState());
  let [calculatorSource, calculatorSourceSet] = useState('');
  let [calculatorError, calculatorErrorSet] = useState('');
  let [selectedCalculatorYear, selectedCalculatorYearSet] = useState(String(moment().year()));





  let [byDateTime, byDateTimeSet] = useState(isCalculatorPage ? getYearRange(moment().year()) : {
    fromDate: currentDateStartTime(),
    toDate: currentDateEndTime()
  })

  let typeRef = useRef(null);
  let customerRef = useRef(null);
  let productRef = useRef(null);
  let fromDateRef = useRef(null);
  let toDateRef = useRef(null);
  let searchBtnRef = useRef(null);
  let reportRef = useRef(null);


  let [types, typesSet] = useState([{ label: 'All', value: 'all' }, { label: 'Customer Wise', value: 'customer' },
  { label: 'Product Wise', value: 'product' }, { label: 'Product Wise Summary', value: 'product_summary' }]);
  let [selectedType, selectedTypeSet] = useState({ label: 'All', value: 'all' });

  useEffect(() => {
    getCusomers();
    getProducts()
  }, []);

  useEffect(() => {
    if (isCalculatorPage) {
      const yearRange = getYearRange(selectedCalculatorYear);
      byDateTimeSet(yearRange);
      loadCalculatorData(yearRange);
    }
  }, [isCalculatorPage, selectedCalculatorYear]);

  const getCalculatorResult = (values) => {
    const totalSales = toSafeNumber(values.totalSales);
    const totalPurchaseAmount = toSafeNumber(values.totalPurchaseAmount);
    const saleProfitLoss = toSafeNumber(values.saleProfitLoss);
    const cashTranProfit = toSafeNumber(values.cashTranProfit);
    const serviceIncomeAmount = toSafeNumber(values.serviceIncomeAmount);
    const serviceExpenseAmount = toSafeNumber(values.serviceExpenseAmount);
    const salesDiscount = toSafeNumber(values.salesDiscount);
    const productDamageAmount = toSafeNumber(values.productDamageAmount);
    const materialDamageAmount = toSafeNumber(values.materialDamageAmount);
    const cashTranLoss = toSafeNumber(values.cashTranLoss);
    const employeeSalaryPay = toSafeNumber(values.employeeSalaryPay);
    const otherIncome = cashTranProfit + serviceIncomeAmount;
    const totalExpenses =
      serviceExpenseAmount +
      salesDiscount +
      productDamageAmount +
      materialDamageAmount +
      cashTranLoss +
      employeeSalaryPay;
    const profit = saleProfitLoss + otherIncome - totalExpenses;
    const status = profit > 0 ? 'Profit' : profit < 0 ? 'Loss' : 'Break Even';

    return {
      totalSales,
      totalPurchaseAmount,
      saleProfitLoss,
      cashTranProfit,
      serviceIncomeAmount,
      serviceExpenseAmount,
      salesDiscount,
      productDamageAmount,
      materialDamageAmount,
      cashTranLoss,
      employeeSalaryPay,
      otherIncome,
      totalExpenses,
      profit,
      status,
      openingStock: 0,
      purchases: totalPurchaseAmount,
      closingStock: 0,
      cogs: totalPurchaseAmount,
    };
  };

  const exportCalculatorCsv = (values) => {
    const result = getCalculatorResult(values);
    const rows = [
      ['Field', 'Amount'],
      ['Total Sales', result.totalSales],
      ['Total Purchased / Sold Item Purchase Cost', result.totalPurchaseAmount],
      ['Product Profit/Loss', result.saleProfitLoss],
      ['Cash Transaction Income', result.cashTranProfit],
      ['Service Income', result.serviceIncomeAmount],
      ['Other Income Total', result.otherIncome],
      ['Service Expense', result.serviceExpenseAmount],
      ['Sales Discount', result.salesDiscount],
      ['Product Damage', result.productDamageAmount],
      ['Material Damage', result.materialDamageAmount],
      ['Cash Expense', result.cashTranLoss],
      ['Employee Payment', result.employeeSalaryPay],
      ['Expense Total', result.totalExpenses],
      ['Total Profit/Loss', result.profit],
      ['Status', result.status],
    ];

    const csv = rows
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', `profit-calculator-${moment().format('YYYY-MM-DD-HH-mm')}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const loadCalculatorData = async (range = byDateTime) => {
    const payload = {
      fromDate: range.fromDate,
      toDate: range.toDate,
      customerId: selectedCustomer != null ? selectedCustomer.customer_id : null,
      prodId: selectedProduct != null ? selectedProduct.prod_id : null,
    };

    calculatorLoadingSet(true);
    calculatorErrorSet('');

    const headers = { headers: { 'auth-token': authInfo.token } };

    try {
      const [salesRes, othersRes] = await Promise.all([
        axios.post(`${API_URL}/api/get-sales-profit-loss`, { ...payload }, headers),
        axios.post(`${API_URL}/api/get-others-profit-loss`, { ...payload }, headers),
      ]);
      const salesReport = Array.isArray(salesRes?.data) ? salesRes.data : [];
      const othersSummary = othersRes?.data || {};
      const soldAmount = _.sumBy(salesReport, ({ details }) =>
        _.sumBy(details || [], (detail) => toSafeNumber(detail.sale_prod_total))
      );
      const purchaseAmount = _.sumBy(salesReport, ({ details }) =>
        _.sumBy(details || [], (detail) => toSafeNumber(detail.purchasedAmount))
      );
      const saleProfitLoss = _.sumBy(salesReport, ({ details }) =>
        _.sumBy(details || [], (detail) => toSafeNumber(detail.productProfitLoss))
      );
      const discount = _.sumBy(salesReport, (sale) => toSafeNumber(sale.sale_discount_amount));

      const nextState = createCalculatorState();
      nextState.totalSales = String(soldAmount);
      nextState.totalPurchaseAmount = String(purchaseAmount);
      nextState.saleProfitLoss = String(saleProfitLoss);
      nextState.cashTranProfit = String(toSafeNumber(othersSummary.cashTranProfit));
      nextState.serviceIncomeAmount = String(toSafeNumber(othersSummary.serviceIncomeAmount));
      nextState.serviceExpenseAmount = String(toSafeNumber(othersSummary.serviceExpenseAmount));
      nextState.salesDiscount = String(discount);
      nextState.productDamageAmount = String(toSafeNumber(othersSummary.productDamageAmount));
      nextState.materialDamageAmount = String(toSafeNumber(othersSummary.materialDamageAmount));
      nextState.cashTranLoss = String(toSafeNumber(othersSummary.cashTranLoss));
      nextState.employeeSalaryPay = String(toSafeNumber(othersSummary.employeeSalaryPay));

      calculatorValuesSet(nextState);
      calculatorSourceSet('Profit & Loss report summary loaded for the selected year.');
    } catch (error) {
      calculatorErrorSet(error?.response?.data?.message || 'Could not load profit & loss summary from backend.');
      calculatorSourceSet('');
    } finally {
      calculatorLoadingSet(false);
    }
  };

  const renderCalculatorPage = () => {
    const result = getCalculatorResult(calculatorValues);
    const profitBg = result.profit < 0 ? '#fde9ec' : '#e3f3ef';
    const resultBg = '#eef6f5';
    const yearOptions = Array.from({ length: 8 }, (_, index) => {
      const year = moment().year() - index;
      return { label: String(year), value: String(year) };
    });
    const calculatorRows = [
      { label: 'Total Sales', value: result.totalSales, bg: '#fff8e9' },
      { label: 'Total Purchased / Sold Item Purchase Cost', value: result.totalPurchaseAmount, bg: '#fff8e9' },
      { label: 'Product Profit/Loss', value: result.saleProfitLoss, bg: resultBg },
      { label: 'Income from Cash Transaction (+)', value: result.cashTranProfit, bg: '#fff8e9' },
      { label: 'Income from Services (+)', value: result.serviceIncomeAmount, bg: '#fff8e9' },
      { label: 'Other Income Total', value: result.otherIncome, bg: resultBg },
      { spacer: true },
      { label: 'Expense for Services Item (-)', value: result.serviceExpenseAmount, bg: '#fff8e9' },
      { label: 'Sales Discount (-)', value: result.salesDiscount, bg: '#fff8e9' },
      { label: 'Product Total Damage (-)', value: result.productDamageAmount, bg: '#fff8e9' },
      { label: 'Material Total Damage (-)', value: result.materialDamageAmount, bg: '#fff8e9' },
      { label: 'Expense (-)', value: result.cashTranLoss, bg: '#fff8e9' },
      { label: 'Employee Payment (-)', value: result.employeeSalaryPay, bg: '#fff8e9' },
      { label: 'Total Expenses', value: result.totalExpenses, bg: resultBg },
      { label: 'Total Profit / Loss', value: result.profit, bg: profitBg, color: result.profit < 0 ? '#b42318' : '#0F7E77' },
    ];

    return (
      <div style={{ padding: '12px' }}>
        <Paper style={{ overflow: 'hidden' }}>
          <div style={{ background: '#0F7E77', color: '#fff', padding: '10px 14px', fontSize: '22px', fontWeight: 700 }}>
            Profit Calculator (লাভ হিসাব পত্র)
          </div>
          <div style={{ padding: '10px 14px', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
            <div>
              Yearly statement
              <br />
              {moment(byDateTime.fromDate).format('DD MMM YYYY')} to {moment(byDateTime.toDate).format('DD MMM YYYY')}
            </div>
            <div style={{ minWidth: 160 }}>
              <Select
                value={yearOptions.find((option) => option.value === String(selectedCalculatorYear))}
                onChange={(option) => {
                  if (!option) return;
                  selectedCalculatorYearSet(option.value);
                }}
                options={yearOptions}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: 42,
                    borderColor: '#0F7E77',
                    boxShadow: 'none',
                    '&:hover': { borderColor: '#0F7E77' },
                  }),
                  singleValue: (base) => ({ ...base, color: '#0F7E77', fontWeight: 700 }),
                  placeholder: (base) => ({ ...base, color: '#0F7E77' }),
                }}
              />
            </div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <Button
                onClick={() => loadCalculatorData(getYearRange(selectedCalculatorYear))}
                variant="outlined"
                style={{ borderColor: '#0F7E77', color: '#0F7E77' }}
                disabled={calculatorLoading}
              >
                Reload
              </Button>
              <Button
                onClick={() => exportCalculatorCsv(calculatorValues)}
                variant="outlined"
                style={{ borderColor: '#007CA9', color: '#007CA9' }}
                disabled={calculatorLoading}
              >
                Export CSV
              </Button>
              <Button
                component={Link}
                to="/reports/profit-loss"
                variant="contained"
                style={{ background: '#0F7E77', color: '#fff' }}
              >
                Back to Report
              </Button>
            </div>
          </div>

          {calculatorLoading ? (
            <div style={{ padding: '26px 14px', textAlign: 'center' }}>Loading backend values...</div>
          ) : (
            <>
              {calculatorError ? (
                <div style={{ margin: '12px 14px 0', padding: '10px 12px', background: '#fff2f2', color: '#b30000', border: '1px solid #f1c4c4' }}>
                  {calculatorError}
                </div>
              ) : null}
              {calculatorSource ? (
                <div style={{ margin: '12px 14px 0', padding: '10px 12px', background: '#eef8ff', border: '1px solid #cde8ff' }}>
                  {calculatorSource}
                </div>
              ) : null}

              <TableContainer style={{ padding: '14px' }}>
                <Table size="small" aria-label="profit summary table">
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700, fontSize: '18px', background: '#0F7E77', color: '#fff' }} colSpan={2}>
                        Profit Summary
                      </TableCell>
                    </TableRow>
                    {calculatorRows.map((row, index) => (
                      row.spacer ? (
                        <TableRow key={`calculator-row-${index}`}>
                          <TableCell colSpan={2} style={{ background: '#ffffff', height: 16 }} />
                        </TableRow>
                      ) : (
                        <TableRow key={`calculator-row-${index}`}>
                          <TableCell style={{ fontWeight: 700 }}>{row.label}:</TableCell>
                          <TableCell style={{ background: row.bg, textAlign: 'right', fontSize: '18px', fontWeight: 700, color: row.color || '#000' }}>
                            {format(toSafeNumber(row.value).toFixed(2))}
                          </TableCell>
                        </TableRow>
                      )
                    ))}
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Status:</TableCell>
                      <TableCell style={{ background: resultBg, textAlign: 'right', fontSize: '18px', fontWeight: 700, color: '#0F7E77' }}>
                        {result.status}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2} style={{ background: '#0F7E77', color: '#fff', fontWeight: 700 }}>
                        Notes
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2}>
                        This summary uses the same backend data and formula as the Profit & Loss report for the selected year.
                        Opening Stock and Closing Stock are not included on this calculator page.
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <TableContainer style={{ padding: '14px', display: 'none' }}>
                <Table size="small" aria-label="profit calculator table">
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700, fontSize: '18px', background: '#0F7E77', color: '#fff' }} colSpan={2}>
                        Profit Calculator (লাভ হিসাব পত্র)
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Opening Stock (বছরের শুরুতে স্টক):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.openingStock.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Purchases (বছরে কেনা মাল):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.purchases.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Closing Stock (বছরের শেষ স্টক):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.closingStock.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Total Sales (মোট বিক্রি):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.totalSales.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Other Income:</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.otherIncome.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Total Expenses (অন্যান্য খরচ):</TableCell>
                      <TableCell style={{ background: '#fff8e9', textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.totalExpenses.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2} style={{ background: '#ffffff', height: 16 }} />
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>COGS = Sold item purchase cost after returns:</TableCell>
                      <TableCell style={{ background: resultBg, textAlign: 'right', fontSize: '18px', fontWeight: 700 }}>{format(result.cogs.toFixed(2))}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Profit = Sales + Other Income - COGS - Expenses:</TableCell>
                      <TableCell style={{ background: profitBg, textAlign: 'right', fontSize: '18px', fontWeight: 700, color: result.profit < 0 ? '#b42318' : '#0F7E77' }}>
                        {format(result.profit.toFixed(2))}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: 700 }}>Status:</TableCell>
                      <TableCell style={{ background: resultBg, textAlign: 'right', fontSize: '18px', fontWeight: 700, color: '#0F7E77' }}>
                        {result.status}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2} style={{ background: '#0F7E77', color: '#fff', fontWeight: 700 }}>
                        Notes
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2}>
                        Opening Stock, Purchases, Closing Stock, Sales, Other Income, COGS and Expenses are loaded from the dedicated backend calculator summary and shown read-only.
                        The page auto-calculates the selected year statement.
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Paper>
      </div>
    );
  };

  let getProducts = async () => {
    await axios.post(`${API_URL}/api/get-individual-products`, { 'select-type': 'active' }, { headers: { 'auth-token': authInfo.token } }).then(res => [
      productsSet(res.data.message)
    ]);
  }



  let getCusomers = async () => {
    await axios.post(`${API_URL}/api/get-customers`, { 'select-type': 'active' }, { headers: { 'auth-token': authInfo.token } }).then(res => {
      customersSet(res.data.message)
    })
  }




  let getSearchResult = async () => {
    const payload = {
      fromDate: byDateTime.fromDate,
      toDate: byDateTime.toDate
    };

    if (selectedCustomer != null) {
      payload.customerId = selectedCustomer.customer_id;
    }

    if (selectedProduct != null) {
      payload.prodId = selectedProduct.prod_id;
    }

    reportLoadingSet(true)

    try {
      if (selectedType.value != 'product_summary') {
        const res = await axios.post(`${API_URL}/api/get-sales-profit-loss`, { ...payload }, { headers: { 'auth-token': authInfo.token } });
        reportSet(res.data)

        let soldAmount = _.sumBy(res.data, ({ details }) => _.sumBy(details, 'sale_prod_total'));
        totalSoldAmountSet(soldAmount);

        let purchaseAmount = _.sumBy(res.data, ({ details }) => _.sumBy(details, 'purchasedAmount'));
        totalPurchaseAmountSet(purchaseAmount);

        let prodProfitLoss = _.sumBy(res.data, ({ details }) => _.sumBy(details, 'productProfitLoss'));
        totalSaleProfitLossSet(prodProfitLoss);

        let discount = _.sumBy(res.data, 'sale_discount_amount');
        totalSaleDiscountSet(discount);

        printSet(true)
      } else {
        const res = await axios.post(`${API_URL}/api/get-product-profit-loss`, { ...payload }, { headers: { 'auth-token': authInfo.token } });
        productWiseProfitSet(res.data)

        let prodProfitAmount = res.data.reduce((prev, curr) => {
          return prev + parseFloat(curr.prod_profit_amount)
        }, 0);

        productProfitSet(prodProfitAmount)
        printSet(true)
      }

      const othersRes = await axios.post(`${API_URL}/api/get-others-profit-loss`, { ...payload }, { headers: { 'auth-token': authInfo.token } });
      othersReportSet(othersRes.data)
    } catch (err) {
      console.error(err);
      swal("Error", "Profit loss report load kora jayni. Date/filter value check kore abar try korun.", "error");
    } finally {
      reportLoadingSet(false)
    }
  }


  let ReportDom = React.forwardRef((props, ref) => {
    return (<div ref={ref}>
      <InstitutionProfile />

      <div style={{ clear: 'both' }}></div>
      <Paper style={{ width: '100%', paddingLeft: '10px', paddingRight: '10px' }} className="print-source">
        <p style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>Profit  Loss Report</p>

        <p style={{ float: 'left', width: '30%', textAlign: 'left', margin: 0, padding: 0, fontSize: '16px' }}>
          {selectedCustomer != null ? `Customer : ${selectedCustomer != null ? selectedCustomer.customer_name : ''}` : ''}
        </p>

        <p style={{ float: 'right', width: '40%', textAlign: 'right', margin: 0, padding: 0 }}> Statement From {moment(byDateTime.dateTimeFrom).format(dateTimeFormat)} <br /> TO {moment(byDateTime.dateTimeTo).format(dateTimeFormat)}
        </p>
      </Paper>


      {

        selectedType.value != 'product_summary' ? (

          report.length > 0 ? (
            <Paper className={classes.paper} style={{ marginTop: '8px', marginBottom: '5px' }} >


              <TableContainer >
                <Table className={classes.table} size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" style={{ width: '1%' }}> Code</TableCell>
                      <TableCell align="right" style={{ width: '10%' }}>Product Name</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Sold Rate</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Sold Quantity</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Sold </TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Purchase Rate</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Purchased</TableCell>
                      <TableCell align="right" style={{ width: '15%' }}>Product Profit/Loss</TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      report.map((sale, index) => (
                        <>
                          <TableRow key={index}>
                            <TableCell colSpan={8}>
                              Sales Invoice No : {sale.sale_invoice} |
                              Sales Date & Time : {moment(sale.sale_created_isodt).format('DD MMM Y h:m a')} |
                              Customer Name : {sale.customer_name} |
                              Customer Code : {sale.customer_code} |
                              Discount : {sale.sale_discount_amount}

                            </TableCell>
                          </TableRow>

                          {
                            sale.details.map((product, sl) => (
                              <TableRow key={sl}>

                                <TableCell align="left">{product.prod_code}</TableCell>
                                <TableCell align="right">{product.prod_name}</TableCell>
                                <TableCell align="right">{product.sale_rate}</TableCell>
                                <TableCell align="right">{product.sale_qty} {product.prod_unit_name}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.sale_prod_total).toFixed(2))}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.sale_prod_purchase_rate).toFixed(2))}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.purchasedAmount).toFixed(2))}</TableCell>
                                <TableCell align="right">{format(parseFloat(product.productProfitLoss).toFixed(2))}</TableCell>
                              </TableRow>
                            ))
                          }


                          {
                            <TableRow key={index + 1} style={{ background: '#E3EAE7' }}>
                              <TableCell colSpan={3} style={{ textAlign: 'right' }}>Sub Total : </TableCell>
                              <TableCell align="right" colSpan={2}>   {format(parseFloat(_.sumBy(sale.details, 'sale_prod_total')).toFixed(2))}</TableCell>
                              <TableCell align="right" colSpan={2}> {format(parseFloat(_.sumBy(sale.details, 'purchasedAmount')).toFixed(2))}</TableCell>
                              <TableCell align="right" colSpan={2}> {format(parseFloat(_.sumBy(sale.details, 'productProfitLoss')).toFixed(2))}</TableCell>



                            </TableRow>

                          }

                        </>
                      ))
                    }


                    <TableRow key={0} style={{ background: '#BDD5CA' }}>
                      <TableCell colSpan={3} style={{ textAlign: 'right' }}> Total : </TableCell>
                      <TableCell align="right" colSpan={2}> Total Sold :  {format(parseFloat(totalSoldAmount).toFixed(2))}</TableCell>
                      <TableCell align="right" colSpan={2}> Total Purchased : {format(parseFloat(totalPurchaseAmount).toFixed(2))}</TableCell>
                      <TableCell align="right" colSpan={2}> Total Profit/Loss : {format(parseFloat(totalSaleProfitLoss).toFixed(2))}</TableCell>



                    </TableRow>



                    <TableRow  >
                      <TableCell colSpan={7} align="right">Income from Cash Transaction (+)</TableCell>

                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranProfit).toFixed(2)) : 0}</TableCell>
                    </TableRow>


                    <TableRow  >
                      <TableCell colSpan={7} align="right">Income from Services (+)</TableCell>

                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.serviceIncomeAmount).toFixed(2)) : 0}</TableCell>
                    </TableRow>


                    <TableRow>

                      <TableCell colSpan={7} align="right">Expense for Services Item (-)</TableCell>
                      <TableCell align="right"> {othersReport != null ? format(parseFloat(othersReport.serviceExpenseAmount).toFixed(2)) : 0}</TableCell>
                    </TableRow>
                    <TableRow  >

                      <TableCell colSpan={7} align="right">Sales Discount (-) </TableCell>
                      <TableCell align="right">{format(parseFloat(totalSaleDiscount).toFixed(2))}</TableCell>

                    </TableRow>
                    <TableRow  >

                      <TableCell colSpan={7} align="right">Product Total Damage (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.productDamageAmount).toFixed(2)) : 0}</TableCell>



                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={7} align="right">Material Total Damage (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.materialDamageAmount).toFixed(2)) : 0}</TableCell>
                    </TableRow>
                    <TableRow  >
                      <TableCell colSpan={7} align="right">Expense (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranLoss).toFixed(2)) : 0}</TableCell>


                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={7} align="right">Employee Payment (-) </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.employeeSalaryPay).toFixed(2)) : 0}</TableCell>

                    </TableRow>
                    <TableRow  >


                      <TableCell colSpan={7} align="right">Total Profit / Loss   </TableCell>
                      <TableCell align="right">{othersReport != null ? format(parseFloat((totalSaleProfitLoss + parseFloat(othersReport.cashTranProfit) + parseFloat(othersReport.serviceIncomeAmount)) -
                        parseFloat(othersReport.productDamageAmount + parseFloat(othersReport.cashTranLoss) +
                          parseFloat(othersReport.employeeSalaryPay) + parseFloat(totalSaleDiscount) + parseFloat(othersReport.materialDamageAmount) + parseFloat(othersReport.serviceExpenseAmount))).toFixed(2)) : 0}</TableCell>

                    </TableRow>















                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          ) : ''

        ) : (<>


          <Paper className={classes.paper} style={{ marginTop: '8px', marginBottom: '5px' }} >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Product Name</TableCell>
                    <TableCell>Product Code</TableCell>
                    <TableCell>Sold Qty</TableCell>
                    <TableCell>Sold Amount</TableCell>
                    <TableCell>Purchased Amount</TableCell>
                    <TableCell>Profit Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productWiseProfit.map((prod) => (
                    <TableRow>
                      <TableCell style={{ width: '20%' }}>{prod.prod_name}</TableCell>
                      <TableCell>{prod.prod_code}</TableCell>
                      <TableCell>{prod.prod_sold_qty}</TableCell>
                      <TableCell>{format(parseFloat(prod.prod_sold_amount).toFixed(2))}</TableCell>
                      <TableCell>{format(parseFloat(prod.prod_purchased_amount).toFixed(2))}</TableCell>
                      <TableCell style={{ textAlign: 'right' }}>{format(parseFloat(prod.prod_profit_amount).toFixed(2))}</TableCell>
                    </TableRow>
                  ))}

                  <TableRow style={{ background: '#eaeaea' }}>
                    <TableCell colSpan={2} style={{ textAlign: 'right' }}>Total : </TableCell>
                    <TableCell>{productWiseProfit.reduce((prev, curr) => { return prev + parseFloat(curr.prod_sold_qty) }, 0)}</TableCell>
                    <TableCell>{format(productWiseProfit.reduce((prev, curr) => { return prev + parseFloat(curr.prod_sold_amount) }, 0).toFixed(2))}</TableCell>
                    <TableCell>{format(productWiseProfit.reduce((prev, curr) => { return prev + parseFloat(curr.prod_purchased_amount) }, 0).toFixed(2))}</TableCell>
                    <TableCell style={{ textAlign: 'right' }}>{format(parseFloat(productProfit).toFixed(2))}</TableCell>
                  </TableRow>





                  <TableRow  >
                    <TableCell colSpan={5} align="right">Received from Cash Transaction (+)</TableCell>

                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranProfit).toFixed(2)) : 0}</TableCell>
                  </TableRow>


                  <TableRow  >
                    <TableCell colSpan={5} align="right">Income from Services (+)</TableCell>

                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.serviceIncomeAmount).toFixed(2)) : 0}</TableCell>
                  </TableRow>


                  <TableRow>

                    <TableCell colSpan={5} align="right">Expense for Services Item (-)</TableCell>
                    <TableCell align="right"> {othersReport != null ? format(parseFloat(othersReport.serviceExpenseAmount).toFixed(2)) : 0}</TableCell>
                  </TableRow>
                  <TableRow  >

                    <TableCell colSpan={5} align="right">Sales Discount (-) </TableCell>
                    <TableCell align="right">{format(parseFloat(totalSaleDiscount).toFixed(2))}</TableCell>

                  </TableRow>
                  <TableRow  >

                    <TableCell colSpan={5} align="right">Product Total Damage (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.productDamageAmount).toFixed(2)) : 0}</TableCell>



                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={5} align="right">Material Total Damage (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.materialDamageAmount).toFixed(2)) : 0}</TableCell>
                  </TableRow>
                  <TableRow  >
                    <TableCell colSpan={5} align="right">Expense (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.cashTranLoss).toFixed(2)) : 0}</TableCell>


                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={5} align="right">Employee Payment (-) </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat(othersReport.employeeSalaryPay).toFixed(2)) : 0}</TableCell>

                  </TableRow>
                  <TableRow  >


                    <TableCell colSpan={5} align="right">Total Profit / Loss   </TableCell>
                    <TableCell align="right">{othersReport != null ? format(parseFloat((productProfit + parseFloat(othersReport.cashTranProfit) + parseFloat(othersReport.serviceIncomeAmount)) -
                      parseFloat(othersReport.productDamageAmount + parseFloat(othersReport.cashTranLoss) +
                        parseFloat(othersReport.employeeSalaryPay) + parseFloat(totalSaleDiscount) + parseFloat(othersReport.materialDamageAmount) + parseFloat(othersReport.serviceExpenseAmount))).toFixed(2)) : 0}</TableCell>

                  </TableRow>


                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

        </>)
      }
    </div>)
  })

  if (isCalculatorPage) {
    return renderCalculatorPage();
  }

  return (
    <div className={classes.root}>
      <NetworkLoaderOverlay visible={reportLoading} message="Loading report..." />
      <Paper className={classes.paper} style={{ marginTop: '-25px', marginBottom: '5px' }}>
        <h4 style={{
          textAlign: 'left', margin: 0, padding: 0, marginTop: '-10px',
          marginBottom: '2px'
        }}>Profit Loss Report</h4>



        <Grid container spacing={3} >



          <Grid item xs={12} sm={2} >
            <Select
              ref={typeRef}
              value={selectedType}
              onChange={(type) => {
                if (type == null) {
                  return false;
                }
                selectedTypeSet(type);
                selectedCustomerSet(null)
                selectedProductSet(null)
                setTimeout(() => {
                  if (type && type.value === 'customer') {
                    customerRef.current?.focus()
                  } else if (type && (type.value === 'product' || type.value === 'product_summary')) {
                    productRef.current?.focus()
                  } else {
                    fromDateRef.current?.focus()
                  }
                }, 0)
              }}
              options={types}

            />
          </Grid>

          {
            selectedType != null && selectedType.value == 'customer' ? (
              <Grid item xs={12} sm={2} >
                <Autocomplete
                  size="small"

                  autoHighlight
                  openOnFocus={true}
                  style={{ width: '100%', height: '20px' }}
                  options={customers}
                  value={selectedCustomer}
                  getOptionLabel={(option) => option.customer_name}
                  onChange={(event, selectedObj) => {
                    selectedCustomerSet(selectedObj)
                  }}
                  inputRef={customerRef}

                  onKeyDown={event => {
                    if (event.key === "Enter") {
                      setTimeout(() => fromDateRef.current?.focus(), 0)
                    }
                  }}

                  renderInput={(params) => <TextField

                    {...params}
                    label="Customer "
                    variant="outlined"
                  />}
                />
              </Grid>
            ) : ''
          }




          {
            selectedType != null && selectedType.value == 'product' || selectedType.value == 'product_summary' ? (

              <Grid xs={12} sm={2} >

                <Autocomplete
                  openOnFocus={true}
                  autoHighlight={true}
                  style={{ width: '100%', height: '20px', marginTop: '10px' }}
                  options={products}
                  value={selectedProduct}
                  loading={true}
                  size="small"
                  getOptionLabel={(option) => `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()}
                  onChange={(e, product) => {
                    selectedProductSet(product)
                  }}
                  onKeyDown={event => {
                    if (event.key === "Enter") {
                      setTimeout(() => fromDateRef.current?.focus(), 0)
                    }
                  }}
                  renderInput={(params) => <TextField
                    inputRef={productRef}
                    {...params}
                    label="choose a product"
                    variant="outlined"

                  />}

                />
              </Grid>


            ) : ''
          }


          <Grid item xs={12} sm={2} style={{ marginBottom: '-9px' }} >
            <MuiPickersUtilsProvider utils={DateFnsUtils} >

              <KeyboardDatePicker
                inputRef={fromDateRef}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    toDateRef.current.focus()
                  }
                }}
                style={{ width: '100%', marginTop: '' }}
                value={byDateTime.fromDate}
                onChange={(datet) => {
                  byDateTimeSet({ ...byDateTime, fromDate: datet })
                }}
                label="From Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>


          <Grid item xs={12} sm={2} style={{ marginBottom: '-9px' }} >
            <MuiPickersUtilsProvider utils={DateFnsUtils} >

              <KeyboardDatePicker
                inputRef={toDateRef}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    searchBtnRef.current.focus()
                  }
                }}
                style={{ width: '100%', marginTop: '' }}
                value={byDateTime.toDate}
                onChange={(datet) => {
                  byDateTimeSet({ ...byDateTime, toDate: datet })

                }}
                label="To Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={1} >
            <Button style={{ marginTop: '5px', marginLeft: 'auto', fontSize: '14px' }}
              variant="contained"
              color="primary"
              className={classes.button}
              startIcon={<SearchIcon />}
              onClick={getSearchResult}
              disabled={reportLoading ? true : false}
              buttonRef={searchBtnRef}
            >
              Search
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {
        print ? (
          <Grid container >
            <Grid item xs={12} sm={12} >
              <Paper style={{ borderRadius: '0px', marginTop: '-7px' }}>
                <ReactToPrint
                  trigger={() => <PrintIcon style={{ cursor: 'pointer', marginLeft: '30px', marginTop: '3px', marginBottom: '-8px' }} />}
                  content={() => reportRef.current}
                />
              </Paper>

            </Grid>
          </Grid>
        ) : ''
      }

      <ReportDom ref={reportRef} />

    </div>

  )
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: '100%',
    marginTop: '5px'
  },
  plusLinkDiv: {
    position: 'relative'
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: '-21px',
    fontSize: '29px',
    height: '21px',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    color: '#3e8d54'
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer
  }
}
export default connect(mapStateToPops, { currentRouteSet })(CustomerTransactionHistory);
